import { BusinessType } from "../../MoneyTransfer/BusinessType.tsx";
import { useState } from "react";
import { AnalyticsParamsBag } from "../../MoneyTransfer/AnalyticsParamsBag.ts";
import { createStripeAdapterAxiosClient } from "../../Stripe/createStripeAdapterAxiosClient.ts";
import { StripeOrderDTO } from "../../Stripe/StripeOrderDTO.ts";
import { ItemType, NormasTeachingCheckoutFormData } from "../CheckoutData.ts";

export function useCreateStripeOrder() {
  const [loading, setLoading] = useState(false);

  const createStripeOrder = async (
    data: NormasTeachingCheckoutFormData,
    normasTeachingItemId: string,
    analyticsParams?: AnalyticsParamsBag,
    productType?: ItemType,
  ) => {
    try {
      setLoading(true);
      const { data: order } =
        await createStripeAdapterAxiosClient().post<StripeOrderDTO>(
          `/payment-intent/card`,
          {
            analytics: analyticsParams,
            email: data.customer.email,
            firstName: data.customer.firstName,
            lastName: data.customer.lastName,
            normasTeachingProductId: normasTeachingItemId,
            participants: data.participants,
            invoiceInfo: data.invoiceRequired
              ? (() => {
                  switch (data.businessType) {
                    case BusinessType.Person:
                      return {
                        requested: true,
                        businessType: BusinessType.Person,
                        taxCode: data.taxCode,
                        address: data.address,
                      };

                    case BusinessType.IndividualCompany:
                      return {
                        requested: true,
                        businessType: BusinessType.IndividualCompany,
                        pec: data.pec || undefined,
                        sdiCode: data.sdiCode,
                        vat: data.vat,
                        taxCode: data.taxCode,
                        address: data.address,
                      };

                    case BusinessType.Company:
                      return {
                        requested: true,
                        businessType: BusinessType.Company,
                        pec: data.pec || undefined,
                        sdiCode: data.sdiCode,
                        vat: data.vat,
                        taxCode: data.taxCode,
                        address: data.address,
                        businessName: data.businessName,
                      };

                    default:
                      throw new Error(
                        `Tipo di business non supportato: ${data.businessType}`,
                      );
                  }
                })()
              : {
                  requested: false,
                },
            numberOfInstallments: data.numberOfInstallments
              ? data.numberOfInstallments
              : undefined,
            productType: productType || ItemType.Product,
            bundleParticipants: data.bundleParticipants,
            coupon: data.coupon,
            promos: data.promos,
          },
        );

      return {
        order,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    createStripeOrder,
    loading,
  };
}
